import { all, put, takeLatest } from 'redux-saga/effects';
import store from '../../../../../store/store';

import MasterService from '../../../../../services/MasterService';
import { componentKey, setMasterTestUnitList } from './MasterTestUnitSlice';
import { addNotifications } from '../../../../../components/common-components/toaster/ToasterSlice';
import { TOASTER_VARIANT } from '../../../../../components/common-components/toaster/MetToaster';

export const { getMasterTestUnit, createMasterTestUnit, updateMasterTestUnit, deleteMasterTestUnit, bulkUploadMasterTestUnit} = {
    getMasterTestUnit: (payload) => {
        return {
            type: 'MASTER_TEST_UNIT/GET_MASTER_TEST_UNIT_LIST',
            payload,
        };
    },
    createMasterTestUnit: (payload) => {
        return {
            type: 'MASTER_TEST_UNIT/CREATE_MASTER_TEST_UNIT',
            payload,
        };
    },
    updateMasterTestUnit: (payload) => {
        return {
            type: 'MASTER_TEST_UNIT/UPDATE_MASTER_TEST_UNIT_LIST',
            payload,
        };
    },
    deleteMasterTestUnit: (payload) => {
        return {
            type: 'MASTER_TEST_UNIT/DELETE_MASTER_TEST_UNIT_LIST',
            payload,    
        };    
    },
    bulkUploadMasterTestUnit: (payload) => {
        return {
            type: 'MASTER_TEST_UNIT/BULK_UPLOAD_MASTER_TEST_UNIT',
            payload,
        };
    }
};

function* getMasterTestUnitAsync(action) {
    try {
        const response = yield MasterService.getMasterTestUnitList(action.payload);
        const {  status } = response.data; 
        if (status) {
            yield put(setMasterTestUnitList(response.data));
        }
    } catch (error) {
        console.log('error', error);
        yield put(setMasterTestUnitList([]));

    }
}

function* createMasterTestUnitAsync(action) {
    try {
        const response = yield MasterService.createMasterTestUnit(action.payload?.apiPayload);
        const {  status, message } = response.data;
        
        if (status) {
            yield put(addNotifications({ message: message || "Test Unit created successfully", variant: TOASTER_VARIANT.SUCCESS }))
            action.payload?.closeEditModal();
            yield put(getMasterTestUnit());
        }
    } catch (error) {
        yield put(addNotifications({ message: error?.response?.data?.message || "Failed to create test unit", variant: TOASTER_VARIANT.ERROR }))
        console.log('error', error);
    }
}

function* updateMasterTestUnitAsync(action) {
    try {
        const response = yield MasterService.updateMasterTestUnit(action.payload?.id, action.payload?.apiPayload);
        const {  status, message } = response.data;
        
        if (status) {
            yield put(addNotifications({ message: message, variant: TOASTER_VARIANT.SUCCESS }))
            action.payload?.closeEditModal();
            yield put(getMasterTestUnit());
        }
    } catch (error) {
        yield put(addNotifications({ message: error?.response?.data?.message || "Something went wrong", variant: TOASTER_VARIANT.ERROR }))
        console.log('error', error);
    }
}

function* bulkUploadMasterTestUnitAsync(action) {
    try {
        const response = yield MasterService.bulkUploadMasterTestUnit(action.payload?.fileData);
        const {  status, message, validationErrors } = response.data;
        
        if (status) {
            yield put(addNotifications({ message: message || "Bulk upload completed successfully", variant: TOASTER_VARIANT.SUCCESS }))
            action.payload?.closeEditModal();
            yield put(getMasterTestUnit());
        } else if (validationErrors) {
            // Handle validation errors from API
            const errorMessage = Array.isArray(validationErrors) 
                ? validationErrors.join(', ') 
                : validationErrors;
            yield put(addNotifications({ message: errorMessage, variant: TOASTER_VARIANT.ERROR }))
        }
    } catch (error) {
        yield put(addNotifications({ message: error?.response?.data?.message || "Bulk upload failed", variant: TOASTER_VARIANT.ERROR }))
        console.log('error', error);
    }
}

function* deleteMasterTestUnitAsync(action) {
    try {
        const response = yield MasterService.deleteMasterTestUnit(action.payload?.id);
        const {  status, message } = response.data;
        
        if (status) {
            yield put(addNotifications({ message: message, variant: TOASTER_VARIANT.SUCCESS }))
            action.payload?.setOpenDeleteModal();
            yield put(getMasterTestUnit());
        }
    } catch (error) {
        yield put(addNotifications({ message: error?.response?.data?.message || "Something went wrong", variant: TOASTER_VARIANT.ERROR }))
        console.log('error', error);
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getMasterTestUnit().type, getMasterTestUnitAsync), 
        takeLatest(createMasterTestUnit().type, createMasterTestUnitAsync),
        takeLatest(updateMasterTestUnit().type, updateMasterTestUnitAsync) ,
        takeLatest(deleteMasterTestUnit().type, deleteMasterTestUnitAsync),
        takeLatest(bulkUploadMasterTestUnit().type, bulkUploadMasterTestUnitAsync)     
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga); 